// Statsig logomark, cropped from the official wordmark
// (https://www.statsig.com/images/statsig_full.svg). The full wordmark is 118x20,
// which letterboxes to a ~6px sliver in the 36x36 square the catalog renders icons
// into, so only the mark itself is kept here.
export default (
  <svg viewBox="0 0 22.75 20.01" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.3088 4.49339L12.9688 13.9721L9.91947 9.42672L2.85547 19.9574L2.88614 20.0041H15.5968C16.0341 20.0041 16.4435 19.7867 16.6861 19.4241L22.5208 10.7214C22.8128 10.2854 22.8128 9.71872 22.5208 9.28272L19.3075 4.49072H19.3088V4.49339Z"
      fill="#1B2528"
    />
    <path
      d="M9.92424 5.67733L12.9709 10.22L19.8069 0H7.14691C6.70957 0 6.30024 0.217333 6.05757 0.578667L0.222906 9.28C-0.0690938 9.716 -0.0690938 10.2827 0.222906 10.7187L3.38157 15.4293L9.92424 5.67733Z"
      fill="#1B2528"
    />
  </svg>
);
